module.exports = __webpack_public_path__ + "static/media/KCC_New_Constitution_ver 3.4_2020.a5cf3136.pdf";